export default {
  common: {
    welcome: '欢迎',
    login: '登录',
    register: '注册',
    logout: '退出登录',
    home: '首页',
    about: '关于我们',
    contact: '联系我们',
    Jewelry: '珠宝销售',
    jewelrySales: '欢迎使用珠宝销售系统！',
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    hello: '您好！',
    modifyPassword: '修改密码',
    quit: '退出',
    Selection: '选择',
    Shape: '形状',
    Color: '颜色',
    Clarity: '净度',
    Cut: '切工',
    Polish: '抛光',
    Sym: '对称',
    Flu: '荧光',
    Weight: '重量',
    Ct: '克拉',
    Details: '详情',
    Remark: '备注',
    Cert: '证书',
    CertNo: '证书号',
    OrderNo: '订单号',
    Place: '地点',
    Price: '价格',
    Discount: '折扣',
    Rating: '评价',
    Year: '年份',
    Size: '尺寸',
    Table: '台面',
    Depth: '深度',
    Ratio: '比例',
    Status: '状态',
    Action: '操作',
    Operator: '操作员',
    OrderDate: '订单日期',
    Round: '圆形',
    Princess: '公主方',
    Radiant: '雷迪恩',
    Asscher: '阿斯切',
    Marquise: '马眼',
    Oval: '椭圆形',
    Emerald: '祖母绿',
    Pear: '梨形',
    Heart: '心形',
    Cushion: '垫形',
    Triangle: '三角形',
    Others: '其他',
    JewelryInformation: '珠宝信息',
    Selected: '选中',
    TotalW: '总重量',
    TotalP: '总价格',
    Customer: '客户',
    Order: '订单',
    Orders: '我的订单',
    Cart: '购物车',
    Listings: '钻石列表',
    Information: '信息',
    welcome: '欢迎登录',
    RealName: '真实姓名',
    LoginTimes: '登录次数',
    JoinTime: '加入时间',
    LastLogin: '最后登录',
    account: '账号',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirm: '确认密码',
    Tips: '提示',
    confirmLogout: '确认退出',
    diamondSelect: '白钻查询',
    colorDiamondSelect: '彩钻查询',
    shoppingCart: '购物车',
    orderCenter: '订单中心',
    personalCenter: '个人中心',
    languageSwitch: '语言切换',
    Account: '账号',
    Phone: '手机号码',
    Company: '类型',
    Image: '图片',
  },
  pagination: {
    total: '共 {total} 条',
    sizes: '条/页',
    prev: '上一页',
    next: '下一页',
    jumper: '前往',
    page: '页'
  },
  // 框架菜单
  menu: [{
      menuId: 0,
      home: '首页',
      menuName: '主数据中心',
      region: '地址信息管理',
      shipper: '货主管理',
      unit: '单位管理',
      unitMath: '物料单位换算管理',
      materialData: '物料数据管理',
      materialGroup: '物料组管理',
      delivery: '送达方管理',
      sold: '售达方管理',
      business: '事业部管理',
      carriers: '承运商管理',
      driver: '司机管理',
      carManage: '车辆管理',
      factoryDc: '工厂物流中心',
      warehouse: '仓库管理',
      shipperWarehouseStrategy: '分仓策略管理',
      unloading: '卸货点管理',
      message: '经销商管理',
      material: '物料信息'
  }, {
      menuId: 1,
      menuName: '系统管理',
      user: '用户管理',
      role: '角色管理',
      resource: '资源管理',
      appRight: '应用权限管理',
      dataRight: '数据权限组管理',
      org: '组织机构管理',
      systemlog: '系统日志管理',
      portlog: '接口日志管理'
  }, {
      menuId: 2,
      menuName: '订单中心',
      sourceOrder: '来源订单管理',
      orderManage: '订单管理',
      inStorage: '入库分仓管理',
      outStorage: '出库分仓管理',
      outStoragePlan: '出库计划管理',
      inStoragePlan: '入库计划管理',
      distribution: '配送单管理',
      processOrder: '加工订单管理',
      storage: '库存量管理',
      warning: '预警管理',
      salesOrderList: '销售订单列表',
      buyOrderList: '采购订单列表',
      moveOrderList: '移库订单列表',
      inventoryInquireList: '库存查询列表',
      deliverList: '配送单列表'
  }, {
      menuId: 3,
      menuName: '可视化中心',
      processExecution: '单据可视化流程'
  }, {
      menuId: 4,
      menuName: '规则配置中心',
      orderBase: '订单基础节点管理',
      orderNodeClass: '订单节点分类管理',
      orderExtension: '订单节点扩展配置',
      addressMap: '地址映射配置',
      orgStrategy: '组织分仓策略',
      orgRelationship: '组织关系管理',
      nodeGroup: '订单节点管理'
  }],
  // 框架顶部右侧
  navTop: {
      search: '请输入要搜索的内容',
      admin: '管理员',
      exit: '退出',
      logo: {
          title: '益海嘉里',
          des: 'OMS平台'
      }
  },
  // 公共按钮
  button: {
      add: '增加',
      remove: '删除',
      update: '修改',
      view: '查看',
      enable: '启用',
      disable: '禁用',
      cancel: '取消',
      confirm: '确定',
      copy: '复制',
      logoutSuccess: '退出成功',
      tip: '提示',
      save: '保存',
      close: '关闭',
      search: '查询',
      reset: '重置',
      importExcel: '导入',
      exportExcel: '导出',
      upload: '上传',
      download: '下载',
      resetPassword: '重置密码',
      login: '登录',
      getCertNo: '获取证书号',
      export: '导出选中',
      exportAll: '导出全部',
      batchCancel: '批量取消',
      batchOrder: '批量下单',
      batchToCart: '加购物车',
      uploadRapnet: '上传Rap',
  },
  // 操作成功/失败提示信息
  msg: {
      success: '操作成功',
      error: '操作失败',
      wechatDownloadTip: '微信浏览器暂不支持文件下载，请使用浏览器打开进行下载操作'
  }
} 


// WEBPACK FOOTER //
// ./src/i18n/zh-CN.js